import React from 'react'
import PropTypes from 'prop-types'

import { useEventOnMount } from '../../ReactGAUtils/ReactGAUtils'
import Button from '../../Button/Button'
import { PoweredByToastModal } from '../../PoweredByToastModal/PoweredByToastModal'
import PaperPlane from '../../../assets/paper-plane.svg'

import './CreateAccountSuccessModal.css'

const CreateAccountSuccessModal = ({ email, onClose }) => {
  useEventOnMount({
    category: 'User Account',
    action: 'Create Account Success',
    label: 'Modal Dialog'
  })
  return (
    <PoweredByToastModal onClose={onClose}>
      <div styleName='centered'>
        <PaperPlane styleName='plane' />
        <h2>Verify Your Account</h2>
        <p styleName='body'>
          We sent an email to {email}.
          <br />
          Please verify your email to complete your account creation.
        </p>
        <Button data-testid='modal-verify-ok-button' style='linkWide' type='button' onClick={onClose}>
          OK
        </Button>
      </div>
    </PoweredByToastModal>
  )
}

CreateAccountSuccessModal.propTypes = {
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default CreateAccountSuccessModal
